module.exports = __webpack_public_path__ + "media/images/bg/headers/meal-8a589a2ecfb0015e16e3f4e5bc0f41ee.png";